import { Card, CardContent, CardHeader } from '@mui/material';

import { CreateImpactGroupDialog } from './CreateImpactGroupDialog';
import AdminImpactGroupTemplateTable from './table/AdminImpactGroupTemplateTable';

const AdminImpactGroupsPage = () => {
  return (
    <Card
      sx={{
        px: 0.5,
        background: 'none',
        boxShadow: 'none',
      }}
    >
      <CardHeader title="Impact Groups" action={<CreateImpactGroupDialog />} />
      <CardContent>
        <AdminImpactGroupTemplateTable />
      </CardContent>
    </Card>
  );
};

export default AdminImpactGroupsPage;
